import { lazy } from 'react';

const CharityVettingGetStartedEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingGetStartedContainer" */ '../containers/CharityVettingGetStartedContainer'
    ),
);

export default CharityVettingGetStartedEntry;
